import AmbassadorSettings from './AmbassadorSettings';
export default AmbassadorSettings;
